import { Component, OnInit } from '@angular/core';
import { AdminService } from 'app/modules/admin/services/admin.service';
import { User } from 'app/modules/domain/models/user';
import { UserRole } from 'app/modules/domain/enums/userRole';
import { MdDialog } from '@angular/material';
import { EditUserComponent } from '../edit-user/edit-user.component';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  public user: User;
  public rolesString: string;

  constructor(private adminService: AdminService,
              public dialog: MdDialog) { }

  ngOnInit() {
    this.getCurrentUser();
  }

  public openDialog() {
    const dialogRef = this.dialog.open(EditUserComponent, {
      width: '450px',
      data: { name: this.user.name }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result !== this.user.name) {
        this.updateUser(result);
      }
    });
  }

  private getCurrentUser(): void {
    this.adminService.getCurrentUserInfo().subscribe((user: User) => {
      this.user = user;
      const highestRole = Math.max(...user.roles);

      this.rolesString = UserRole[highestRole];
    });
  }

  private updateUser(userName: string): void {
    this.adminService.updateUsername(userName).subscribe(result => {
      if (result) {
        this.user.name = userName;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/myaccount/components/user-info/user-info.component.ts